export const swipeDetect = (el, callback, touchMoveCallback = () => {}, direction) => {
	let touchsurface = el;
	let swipedir;
	let startX;
	let startY;
	let distX;
	let distY;
	let threshold = 100;
	let restraint = 500;
	let allowedTime = 600;
	let wheelThreshold = 50;
	let elapsedTime;
	let startTime;
	let handleSwipe = callback || function() {};

	const handleTouchStart = (e) => {
		let touchobj = e.changedTouches[0];
		swipedir = 'none';
		startX = touchobj.pageX;
		startY = touchobj.pageY;
		startTime = new Date().getTime();
	};

	const handleTouchMove = (e) => {
		let touchobj = e.changedTouches[0];
		distX = touchobj.pageX - startX;
		distY = touchobj.pageY - startY;
		touchMoveCallback(distX, distY);
	};

	const handleTouchEnd = (e) => {
		let touchobj = e.changedTouches[0];
		distX = touchobj.pageX - startX;
		distY = touchobj.pageY - startY;
		elapsedTime = new Date().getTime() - startTime;

		if (elapsedTime <= allowedTime) {
			if (direction === 'horizontal') {			
				if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
					swipedir = (distX < 0) ? 'left' : 'right';
				}
			} else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
				swipedir = (distY < 0) ? 'up' : 'down';
			}
		}

		if (swipedir) {
			handleSwipe(swipedir);
		}
	};

	const handleWheel = (e) => {
		if (e.deltaY > wheelThreshold) {
			swipedir = direction === 'horizontal' ? 'left' : 'up';
			handleSwipe(swipedir);
		} else if (e.deltaY < -wheelThreshold) {
			swipedir = direction === 'horizontal' ? 'right' : 'down';
			handleSwipe(swipedir);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'ArrowDown') {
			handleSwipe('up');
		} else if (e.key === 'ArrowUp') {
			handleSwipe('down');
		}
	};

	touchsurface.addEventListener('touchstart', handleTouchStart, false);
	touchsurface.addEventListener('touchmove', handleTouchMove, false);
	touchsurface.addEventListener('touchend', handleTouchEnd, false);
	touchsurface.addEventListener('wheel', handleWheel, false);
	document.addEventListener('keydown', handleKeyDown, false);

	const remove = () => {
		touchsurface.removeEventListener('wheel', handleWheel, false);
		touchsurface.removeEventListener('touchstart', handleTouchStart, false);
		touchsurface.removeEventListener('touchmove', handleTouchMove, false);
		touchsurface.removeEventListener('touchend', handleTouchEnd, false);
		document.removeEventListener('keydown', handleKeyDown, false);
	};

	return { remove };
};
